export default "__VITE_ASSET__BEnWUIvY__"